export enum StatusEnum {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  BOOSTED = 'BOOSTED',
  TERMINATED = 'TERMINATED',
  CANCELLED = 'CANCELLED',
}
